// Angular
import {
	ChangeDetectorRef,
	Component,
	OnDestroy,
	OnInit,
	ViewEncapsulation,
	ViewChild,
	ElementRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonHelper } from "../../../../core/_config/common.helper";
import { LoginService } from "./services/login.service";
import { SharedService } from "../../../../shared/sharedServices/shared.service";
import { encrypt } from "../../../../utilities/utilityFunctions";
import { HEC_CONSTANTS } from "../../../../utilities/constants";
import { MapsAPILoader } from "@agm/core";
import { GoogleAnalyticsService } from "../../../../shared/sharedServices/google-analytics.service";
import { DeviceDetectorService } from "ngx-device-detector";
import { environment } from "../../../../../environments/environment";
import { LocationService } from "../../../../core/_base/layout/services/location.service";
@Component({
	selector: "kt-login",
	templateUrl: "./login.component.html",
	encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnInit, OnDestroy {
	public loginForm: FormGroup;
	public loading: boolean;
	public emailDropdownOption: any = [];
	model = {
		latitude: 0,
		longitude: 0,
	};
	userDetail = {
		lng: "",
		lat: "",
		ip: "",
		city: "",
		country: "",
		isp: "",
		appVersion: "",
		manufactrer: "",
		model: "",
		platform: "",
		mobileVersion: "",
	};
	geoCoder;
	currentLatitude: number = 0;
	currentLongitude: number = 0;
	currentAddress: string = "";
	desiredAddress: string = "";
	@ViewChild("search", { static: true }) searchElementRef: ElementRef;
	public emailVerified: boolean = false;
	public loginPayload: any;
	public errorMsg: string;
	public isError: boolean = false;
	public alertType: string;
	public phide: boolean = true;
	public idsForOtherDoc: any = [];
	public cnicList: any = [];

	public deviceDetails: any;
	public cnicListIssuues = [];
	userLocation: { lat: number; lng: number } | null = null;

	constructor(
		private router: Router,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef,
		private loginService: LoginService,
		private sharedServices: SharedService,
		private route: ActivatedRoute,
		private gaService: GoogleAnalyticsService,
		private deviceService: DeviceDetectorService,
		private mapsAPILoader: MapsAPILoader,
		private locationService: LocationService
	) {
		this.initLoginForm();
		this.getIpLocation();
		this.deviceCheck();
		this.mapsAPILoader.load().then(() => {
			this.setLocation();
			this.geoCoder = new google.maps.Geocoder;
		});
		this.cnicList.forEach((element) => {
			this.test(element);
		});
		this.route.queryParams.subscribe((params) => {
			const ref = params["ref"];
			if (ref == "research") {
				let details = JSON.parse(localStorage.getItem("loginDetails"));
				if (details["userName"] && details["password"]) {
					this.loginForm.controls.email.patchValue(
						details["userName"]
					);
					this.loginForm.controls.password.patchValue(
						details["password"]
					);
				}
				this.submitLogin();
			}
		});
	}

	async ngOnInit() {
		this.gaService.setPage("/login", "Login");
		// this.requestLocation();

		

  /**
   * Request user's location
   */
   
		// this.sharedServices.openPopupDialog('Eservices', 'HEC has revamped the Foreign Degree Equivalence portal and shifted the services to this portal. User are requested to apply on this portal for Foreign Equivalence Services.','info')
		//       .then((res) => {
		//       });
	}

	ngAfterViewInit() {
		setTimeout(() => {
			document.getElementById("km-loginscreen").classList.add("active");
		}, 100);
	}

	ngOnDestroy(): void {
		this.loading = false;
	}

	 requestLocation() {
		this.locationService.loadGoogleMapsAndSetLocation()
		  .then((coords) => {
			this.userLocation = coords;
			console.log('Location:', coords);
		  })
		  .catch((error) => {
			console.error(error);
		  });
	  }

	public initLoginForm() {
		this.loginForm = this.fb.group({
			email: [
				"",
				Validators.compose([
					Validators.required,
					Validators.maxLength(50),
				]),
			],
			password: [
				"",
				Validators.compose([
					Validators.minLength(8),
					Validators.maxLength(20),
				]),
			],
		});
	}

	public verifyLogin(): void {
		this.markFormsTouched(this.loginForm);
		if (this.loginForm.valid) {
			this.loading = true;
			let payload = {
				data: this.loginForm.controls.email.value,
			};
			this.loginService.verifyUserId(payload).subscribe(
				(res) => {
					if (res == null) {
						this.loading = false;
						this.emailDropdownOption = [];
						this.emailDropdownOption.push({
							value: payload.data,
							label: payload.data,
						});
						this.emailDropdownOption.push({
							value: "OtherOption",
							label: "Use another account",
						});
						this.cdr.detectChanges();
					} else if (
						res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK
					) {
						this.emailVerified = true;
						this.loading = false;
						this.isError = false;
						this.cdr.detectChanges();
						this.emailDropdownOption = [];
						this.emailDropdownOption.push({
							value: payload.data,
							label: payload.data,
						});
						this.emailDropdownOption.push({
							value: "OtherOption",
							label: "Use another account",
						});
					} else if (
						res.statusCode ==
						HEC_CONSTANTS.HTTP_RESPONSE.BUSINESS_ERROR
					) {
						this.isError = true;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.errorMsg =
							HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.INVALID_ACCOUNT;
						this.loading = false;
						this.cdr.detectChanges();
					} else if (
						res.statusCode ==
						HEC_CONSTANTS.HTTP_RESPONSE.ACCOUNT_ERROR
					) {
						this.isError = true;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.errorMsg =
							HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.LOCKED_ACCOUNT;
						this.loading = false;
						this.cdr.detectChanges();
					} else if (
						res.statusCode ==
						HEC_CONSTANTS.HTTP_RESPONSE.BLACKLISTED_ACCOUNT_ERROR
					) {
						this.isError = true;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.errorMsg =
							HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.BLACKLISTED_ACCOUNT;
						this.loading = false;
						this.cdr.detectChanges();
					} else if (
						res.statusCode ==
						HEC_CONSTANTS.HTTP_RESPONSE.UNVERIFIED_ACCOUNT
					) {
						this.isError = true;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.errorMsg =
							HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.UNVERIFIED_ACCOUNT;
						this.loading = false;
						this.cdr.detectChanges();
					} else {
						this.isError = true;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.errorMsg =
							HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.INVALID_ACCOUNT;
						this.loading = false;
						this.cdr.detectChanges();
					}
				},
				(err) => {
					this.isError = true;
					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
					this.errorMsg =
						HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.INVALID_ACCOUNT;
					this.loading = false;
					this.cdr.detectChanges();
				}
			);
		}
	}


	//	Submit Login Function with just EJB Service
	// public submitLogin(): void {
	// 	this.markFormsTouched(this.loginForm)
	// 	if (this.loginForm.valid) {
	// 		this.loading = true;
	// 		this.loginPayload = {
	// 			username: this.loginForm.controls.email.value,
	// 			password: this.loginForm.controls.password.value
	// 		}
	// 		// this.loginService.getToken(this.loginPayload).subscribe(
	// 		// 	(res)=>{
	// 		// 		console.log(res);
	// 		// 	}
	// 		// )
	// 		let userDetails = {
	// 			data: this.userDetail
	// 		}
	// 		this.sharedServices.login(this.loginPayload, userDetails).subscribe(
	// 			(res) => {
	// 				if (res == null) {
	// 					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
	// 					this.loading = false;
	// 					this.isError = true;
	// 					this.errorMsg = HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.INVALID_PASSWORD;
	// 					this.cdr.detectChanges();
	// 				}
	// 				else if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
	// 					let data = encrypt(JSON.stringify(res.data));
	// 					this.loading = false;
	// 					localStorage.setItem('esp-profile-details', data);
	// 					this.cdr.detectChanges();
	// 					localStorage.removeItem('loginDetails')
	// 					console.log(this.sharedServices.checkAdminType(res.data.getSpRole))
	// 					console.log(res.data.getSpRole && this.sharedServices.checkAdminRole(res.data.getSpRole).isRoleFound)
	// 					console.log(this.sharedServices.checkAdminRole(res.data.getSpRole).isRoleFound)
	// 					if (res.data.getSpRole && this.sharedServices.checkAdminRole(res.data.getSpRole).isRoleFound
	// 					) {
	// 						if (this.sharedServices.checkAdminType(res.data.getSpRole) == 'DES') {
	// 							this.router.navigate(['admin-dashboard']);
	// 							this.cdr.detectChanges();

	// 						} else if (this.sharedServices.checkAdminType(res.data.getSpRole) == 'DESF') {
	// 							this.router.navigate(['admin-dashboard']);
	// 							this.cdr.detectChanges();

	// 						}
	// 						else if (this.sharedServices.checkAdminType(res.data.getSpRole) == 'DAS') {
	// 							console.log(this.sharedServices.checkAdminCategory(res.data.getSpRole))
	// 							if (this.sharedServices.checkAdminCategory(res.data.getSpRole) == 'SCH_ADMIN') {
	// 								this.router.navigate(['scheduler']);
	// 								this.cdr.detectChanges();
	// 							}
	// 							else {
	// 								this.router.navigate(['tcs']);
	// 								this.cdr.detectChanges();
	// 							}
	// 						}
	// 						//both roles HEC Admin + UFP for coursera-admin
	// 						else if (this.sharedServices.checkAdminType(res.data.getSpRole) == 'COURSERA') {
	// 							this.router.navigate(['coursera-admin']);
	// 							this.cdr.detectChanges();

	// 						}
	// 						//this if block if we only need specfic role for coursera-admin
	// 						// else if (this.sharedServices.checkAdminType(res.data.getSpRole) == 'COURSERA') {
	// 						// 	//coursera-admin is active for HEC-Admin-Role
	// 						// 	if (this.sharedServices.checkAdminCategory(res.data.getSpRole) == 'HEC_COURSERA_ADMIN') {
	// 						// 		this.router.navigate(['coursera-admin']);
	// 						// 		this.cdr.detectChanges();
	// 						// 	}
	// 						// 	//incase of coursera-admin UFP role, redirect to dashboard
	// 						// 	else {
	// 						// 		this.router.navigate(['dashboard']);
	// 						// 		this.cdr.detectChanges();
	// 						// 	}
	// 						// }
	// 						else {
	// 							this.router.navigate(['dashboard']);
	// 							this.cdr.detectChanges();
	// 						}
	// 					} else {
	// 						this.router.navigate(['dashboard']);
	// 						this.cdr.detectChanges();
	// 					}
	// 				}
	// 				else if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.UNVERIFIED_ACCOUNT) {
	// 					this.isError = true;
	// 					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
	// 					this.errorMsg = HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.UNVERIFIED_ACCOUNT;
	// 					this.loading = false;
	// 					this.cdr.detectChanges();
	// 				}

	// 				else if (res.errors['Locked'] == HEC_CONSTANTS.HTTP_RESPONSE.ACCOUNT_ERROR) {
	// 					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
	// 					this.isError = true;
	// 					this.errorMsg = HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.LOCKED_ACCOUNT;
	// 					this.loading = false;
	// 					this.cdr.detectChanges();
	// 				}
	// 				else if (res.errors['BlackListed'] == HEC_CONSTANTS.HTTP_RESPONSE.BLACKLISTED_ACCOUNT_ERROR) {
	// 					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
	// 					this.isError = true;
	// 					this.errorMsg = HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.BLACKLISTED_ACCOUNT;
	// 					this.loading = false;
	// 					this.cdr.detectChanges();
	// 				}

	// 				else {
	// 					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
	// 					this.isError = true;
	// 					this.errorMsg = HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.INVALID_PASSWORD;
	// 					this.loading = false;
	// 					this.cdr.detectChanges();
	// 				}
	// 			}, (err) => {
	// 				this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
	// 				this.isError = true;
	// 				this.errorMsg = HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.INVALID_PASSWORD;
	// 				this.loading = false;
	// 				this.cdr.detectChanges();
	// 			})

	// 	}
	// }

	// Submit Login Function with EJB and Spring Auth Service
	//EJB+Spring
	// public submitLogin(): void {
	// 	this.markFormsTouched(this.loginForm);
	// 	if (this.loginForm.valid) {
	// 		this.loading = true;
	// 		this.loginPayload = {
	// 			username: this.loginForm.controls.email.value,
	// 			password: this.loginForm.controls.password.value,
	// 		};
	// 		let userDetails = {
	// 			data: this.userDetail,
	// 		};
	// 		this.sharedServices.login(this.loginPayload, userDetails).subscribe(
	// 			(res) => {
	// 				if (res == null) {
	// 					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
	// 					this.loading = false;
	// 					this.isError = true;
	// 					this.errorMsg =
	// 						HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.INVALID_PASSWORD;
	// 					this.cdr.detectChanges();
	// 				} else if (
	// 					res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK
	// 				) {
	// 					let payload = {
	// 						userName: this.loginForm.controls.email.value,
	// 						password: this.loginForm.controls.password.value,
	// 						data: this.userDetail,
	// 					};
	// 					delete payload.data.appVersion;
	// 					delete payload.data.manufactrer;
	// 					delete payload.data.model;
	// 					delete payload.data.platform;
	// 					delete payload.data.mobileVersion;
	// 					this.loginService
	// 						.authenticate(payload)
	// 						.subscribe((response) => {
	// 							if (response && response.token) {
	// 								localStorage.setItem(
	// 									environment.JWT,
	// 									response.token
	// 								);
	// 								localStorage.setItem(
	// 									"springProfileId",
	// 									response.profileId
	// 								);

	// 								this.cdr.detectChanges();
	// 								let data = encrypt(
	// 									JSON.stringify(res.data)
	// 								);
	// 								this.loading = false;
	// 								localStorage.setItem(
	// 									"esp-profile-details",
	// 									data
	// 								);
	// 								this.cdr.detectChanges();
	// 								localStorage.removeItem("loginDetails");
	// 								console.log(
	// 									this.sharedServices.checkAdminType(
	// 										res.data.getSpRole
	// 									)
	// 								);
	// 								console.log(
	// 									res.data.getSpRole &&
	// 									this.sharedServices.checkAdminRole(
	// 										res.data.getSpRole
	// 									).isRoleFound
	// 								);
	// 								console.log(
	// 									this.sharedServices.checkAdminRole(
	// 										res.data.getSpRole
	// 									).isRoleFound
	// 								);
	// 								if (
	// 									res.data.getSpRole &&
	// 									this.sharedServices.checkAdminRole(
	// 										res.data.getSpRole
	// 									).isRoleFound
	// 								) {
	// 									if (
	// 										this.sharedServices.checkAdminType(
	// 											res.data.getSpRole
	// 										) == "DES"
	// 									) {
	// 										this.router.navigate([
	// 											"admin-dashboard",
	// 										]);
	// 										this.cdr.detectChanges();
	// 									} else if (
	// 										this.sharedServices.checkAdminType(
	// 											res.data.getSpRole
	// 										) == "DESF"
	// 									) {
	// 										this.router.navigate([
	// 											"admin-dashboard",
	// 										]);
	// 										this.cdr.detectChanges();
	// 									} else if (
	// 										this.sharedServices.checkAdminType(
	// 											res.data.getSpRole
	// 										) == "DAS"
	// 									) {
	// 										this.router.navigate(["tcs"]);
	// 										this.cdr.detectChanges();
	// 									} else if (
	// 										this.sharedServices.checkAdminType(
	// 											res.data.getSpRole
	// 										) == "COURSERA"
	// 									) {
	// 										this.router.navigate([
	// 											"coursera-admin",
	// 										]);
	// 										this.cdr.detectChanges();
	// 									} else {
	// 										this.router.navigate(["dashboard"]);
	// 										this.cdr.detectChanges();
	// 									}
	// 								} else {
	// 									this.router.navigate(["dashboard"]);
	// 									this.cdr.detectChanges();
	// 								}
	// 							} else if (response.statusDescription) {
	// 								console.log(
	// 									"response",
	// 									response.statusDescription
	// 								);
	// 								this.alertType =
	// 									HEC_CONSTANTS.ERROR_TYPES.error;
	// 								this.loading = false;
	// 								this.isError = true;
	// 								this.errorMsg = response.statusDescription;
	// 								this.cdr.detectChanges();
	// 							} else {
	// 								this.alertType =
	// 									HEC_CONSTANTS.ERROR_TYPES.error;
	// 								this.loading = false;
	// 								this.isError = true;
	// 								this.errorMsg =
	// 									HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_ERROR;
	// 								this.cdr.detectChanges();
	// 							}
	// 						});
	// 				} else if (
	// 					res.statusCode ==
	// 					HEC_CONSTANTS.HTTP_RESPONSE.UNVERIFIED_ACCOUNT
	// 				) {
	// 					this.isError = true;
	// 					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
	// 					this.errorMsg =
	// 						HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.UNVERIFIED_ACCOUNT;
	// 					this.loading = false;
	// 					this.cdr.detectChanges();
	// 				} else if (
	// 					res.errors["Locked"] ==
	// 					HEC_CONSTANTS.HTTP_RESPONSE.ACCOUNT_ERROR
	// 				) {
	// 					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
	// 					this.isError = true;
	// 					this.errorMsg =
	// 						HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.LOCKED_ACCOUNT;
	// 					this.loading = false;
	// 					this.cdr.detectChanges();
	// 				} else if (
	// 					res.errors["BlackListed"] ==
	// 					HEC_CONSTANTS.HTTP_RESPONSE.BLACKLISTED_ACCOUNT_ERROR
	// 				) {
	// 					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
	// 					this.isError = true;
	// 					this.errorMsg =
	// 						HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.BLACKLISTED_ACCOUNT;
	// 					this.loading = false;
	// 					this.cdr.detectChanges();
	// 				} else {
	// 					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
	// 					this.isError = true;
	// 					this.errorMsg =
	// 						HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.INVALID_PASSWORD;
	// 					this.loading = false;
	// 					this.cdr.detectChanges();
	// 				}
	// 			},
	// 			(err) => {
	// 				this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
	// 				this.isError = true;
	// 				this.errorMsg =
	// 					HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.INVALID_PASSWORD;
	// 				this.loading = false;
	// 				this.cdr.detectChanges();
	// 			}
	// 		);
	// 	}
	// }


	//in use
	public submitLogin(): void {
		this.markFormsTouched(this.loginForm);
		if (this.loginForm.valid) {
			this.loading = true;
			this.loginPayload = {
				username: this.loginForm.controls.email.value,
				password: this.loginForm.controls.password.value,
			};
			let userDetails = {
				data: this.userDetail,
			};
			this.sharedServices.login(this.loginPayload, userDetails).subscribe(
				(res) => {
					if (res == null) {
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.loading = false;
						this.isError = true;
						this.errorMsg =
							HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.INVALID_PASSWORD;
						this.cdr.detectChanges();
					} else if (
						res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK
					) {
						let payload = {
							userName: this.loginForm.controls.email.value,
							password: this.loginForm.controls.password.value,
							data: this.userDetail,
						};
						localStorage.setItem('userInfo',JSON.stringify(this.userDetail));
						delete payload.data.appVersion;
						delete payload.data.manufactrer;
						delete payload.data.model;
						delete payload.data.platform;
						delete payload.data.mobileVersion;
						this.loginService
							.authenticate(payload)
							.subscribe((response) => {
								if (response == null) {
									this.alertType =
										HEC_CONSTANTS.ERROR_TYPES.error;
									this.loading = false;
									this.isError = true;
									this.errorMsg =
										HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.INVALID_PASSWORD;
									this.cdr.detectChanges();
								}
								if (
									response.statusCode ==
									HEC_CONSTANTS.HTTP_RESPONSE.OK
								) {
									localStorage.setItem(
										environment.JWT,
										response.data.token
									);
									localStorage.setItem(
										"springProfileId",
										response.data.profileId
									);
									this.cdr.detectChanges();
									
									// Transform getSpRole from object format to array format
									let transformedData = { ...res.data };
									if (transformedData.getSpRole && Array.isArray(transformedData.getSpRole)) {
										transformedData.getSpRole = transformedData.getSpRole.map(role => {
											// Check if it's in object format
											if (role && typeof role === 'object' && role.processAcronym && role.role) {
												return [role.processAcronym, role.role];
											}
											// If already in array format, return as is
											return role;
										});
									}
									
									let data = encrypt(
										JSON.stringify(transformedData)
									);
									this.loading = false;
									localStorage.setItem(
										"esp-profile-details",
										data
									);
									this.cdr.detectChanges();
									localStorage.removeItem("loginDetails");
									console.log(
										this.sharedServices.checkAdminType(
											transformedData.getSpRole
										)
									);
									console.log(
										transformedData.getSpRole &&
										this.sharedServices.checkAdminRole(
											transformedData.getSpRole
										).isRoleFound
									);
									console.log(
										this.sharedServices.checkAdminRole(
											transformedData.getSpRole
										).isRoleFound
									);
									if (
										transformedData.getSpRole &&
										this.sharedServices.checkAdminRole(
											transformedData.getSpRole
										).isRoleFound
									) {
										if (
											this.sharedServices.checkAdminType(
												transformedData.getSpRole
											) == "DES"
										) {
											this.router.navigate([
												"admin-dashboard",
											]);
											this.cdr.detectChanges();
										} else if (
											this.sharedServices.checkAdminType(
												res.data.getSpRole
											) == "DESF"
										) {
											this.router.navigate([
												"admin-dashboard",
											]);
											this.cdr.detectChanges();
										} else if (
											this.sharedServices.checkAdminType(
												res.data.getSpRole
											) == "DAS" || this.sharedServices.checkAdminType(
												res.data.getSpRole
											) == "DAS-COURSERA"
										) {
											this.router.navigate(["tcs"]);
											this.cdr.detectChanges();
										}
										if (
											this.sharedServices.checkAdminType(
												res.data.getSpRole
											) == "COURSERA" || this.sharedServices.checkAdminType(
												res.data.getSpRole
											) == "PCD-COURSERA"
										) {
											this.router.navigate([
												"coursera-admin",
											]);
											this.cdr.detectChanges();
										}
										// else if (this.sharedServices.checkAdminType(res.data.getSpRole) == 'COURSERA') {
										// 	// 	//coursera-admin is active for HEC-Admin-Role
										// 	if (this.sharedServices.checkAdminCategory(res.data.getSpRole) == 'HEC_COURSERA_ADMIN') {
										// 		this.router.navigate(['coursera-admin']);
										// 		this.cdr.detectChanges();
										// 	}
										// 	//incase of coursera-admin UFP role, redirect to dashboard
										// 	else {
										// 		this.router.navigate(['dashboard']);
										// 		this.cdr.detectChanges();
										// 	}
										// }
										if (
											this.sharedServices.checkAdminType(
												res.data.getSpRole
											) == "PCD" || this.sharedServices.checkAdminType(
												res.data.getSpRole
											) == "PCD-COURSERA"
										) {
										for (
											let i = 0;
											i < res.data.getSpRole.length;
											i++
										) {
											const processAcronym = res.data.getSpRole[i].processAcronym || res.data.getSpRole[i][0];
											const roleValue = res.data.getSpRole[i].role || res.data.getSpRole[i][1];
											
											if (
												processAcronym ==
												"PCD" &&
												roleValue ==
												"ADMIN"
											) {
												this.router.navigate([
													"pcd-admin",
												]);
												this.cdr.detectChanges();
											}
											if (
												processAcronym ==
												"PCD" &&
												roleValue ==
												"PCD_UNI_CONTROLLER"
											) {
												this.router.navigate([
													"controller",
												]);
												this.cdr.detectChanges();
											}
										}
											// if no role found then redirect to dashboard
											// this.router.navigate(["dashboard"]);
											// this.cdr.detectChanges();
										} else {
											this.router.navigate(["dashboard"]);
											this.cdr.detectChanges();
										}
									} else {
										this.router.navigate(["dashboard"]);
										this.cdr.detectChanges();
									}
								} else if (response.statusDescription) {
									console.log(
										"response",
										response.statusDescription
									);
									this.alertType =
										HEC_CONSTANTS.ERROR_TYPES.error;
									this.loading = false;
									this.isError = true;
									this.errorMsg = response.statusDescription;
									this.cdr.detectChanges();
								} else {
									this.alertType =
										HEC_CONSTANTS.ERROR_TYPES.error;
									this.loading = false;
									this.isError = true;
									this.errorMsg =
										HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_ERROR;
									this.cdr.detectChanges();
								}
							});
					} else if (
						res.statusCode ==
						HEC_CONSTANTS.HTTP_RESPONSE.UNVERIFIED_ACCOUNT
					) {
						this.isError = true;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.errorMsg =
							HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.UNVERIFIED_ACCOUNT;
						this.loading = false;
						this.cdr.detectChanges();
					} else if (
						res.errors["Locked"] ==
						HEC_CONSTANTS.HTTP_RESPONSE.ACCOUNT_ERROR
					) {
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.isError = true;
						this.errorMsg =
							HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.LOCKED_ACCOUNT;
						this.loading = false;
						this.cdr.detectChanges();
					} else if (
						res.errors["BlackListed"] ==
						HEC_CONSTANTS.HTTP_RESPONSE.BLACKLISTED_ACCOUNT_ERROR
					) {
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.isError = true;
						this.errorMsg =
							HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.BLACKLISTED_ACCOUNT;
						this.loading = false;
						this.cdr.detectChanges();
					} else {
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.isError = true;
						this.errorMsg =
							HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.INVALID_PASSWORD;
						this.loading = false;
						this.cdr.detectChanges();
					}
				},
				(err) => {
					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
					this.isError = true;
					this.errorMsg =
						HEC_CONSTANTS.MESSGAES_LIST.AuthMessages.INVALID_PASSWORD;
					this.loading = false;
					this.cdr.detectChanges();
				}
			);
		}
	}

	public markFormsTouched(form): void {
		CommonHelper.markFormGroupTouched(form);
	}

	public ChangeOption(value) {
		if (value == "OtherOption") {
			this.emailVerified = false;
			this.loginForm.controls.email.patchValue("");
			this.emailDropdownOption = [];
			this.isError = false;
			this.loginForm.controls.password.reset();
		}
	}

	public isControlHasError(
		controlName: string,
		validationType: string
	): boolean {
		const control = this.loginForm.controls[controlName];
		if (!control) {
			return false;
		}
		const result =
			control.hasError(validationType) &&
			(control.dirty || control.touched);
		return result;
	}

	public setLocation(): void {
		this.getCurrentPosition((position, error) => {
			if (position) {
				this.currentLatitude = position.coords.latitude;
				this.currentLongitude = position.coords.longitude;
				this.getCurrentAddress(
					this.currentLatitude,
					this.currentLongitude,
					(address) => {
						this.currentAddress = address;
					}
				);
			}
			this.userDetail.lng = this.currentLongitude.toString();
			this.userDetail.lat = this.currentLatitude.toString();
			this.model = {
				latitude: this.currentLatitude,
				longitude: this.currentLongitude,
			};
		});
	}

	public getCurrentPosition(CallBack: Function): void {
		CommonHelper.getUserCurrentPosition()
			.then((position) => {
				this.loading = false;
				CallBack(position);
			})
			.catch((error) => {
				this.loading = false;
				CallBack(null);
				console.error(error.message);
			});
	}

	public getCurrentAddress(latitude, longitude, CallBack: Function) {
		this.geoCoder.geocode(
			{ location: { lat: latitude, lng: longitude } },
			(results, status) => {
				if (status === "OK") {
					if (results[0]) {
						if (results[0]) {
							results[0].address_components.forEach(
								(element, index) => {
									if (element.types[0] == "country") {
										this.userDetail.country =
											element.long_name;
									}
									if (element.types[0] == "locality") {
										this.userDetail.city =
											element.long_name;
									}
								}
							);
						}
						CallBack(results[0].formatted_address);
					} else {
					}
				} else {
				}
				this.loading = false;
			}
		);
	}

	public getIpLocation() {
		this.loginService.getIpLocation().subscribe((res) => {
			console.log("Location Details: ", res);
			
			console.log(this.deviceDetails);
			this.userDetail.ip = res.ip;
			this.userDetail.isp = "";
			this.userDetail.city = this.userDetail.city
				? this.userDetail.city
				: res.city;
			this.userDetail.lng = this.currentLongitude
				? this.currentLongitude.toString()
				: res.longitude.toString();
			this.userDetail.lat = this.currentLatitude
				? this.currentLatitude.toString()
				: res.latitude.toString();
			this.userDetail.country = this.userDetail.country
				? this.userDetail.country
				: res.country_name;
			this.userDetail.appVersion = "05132022";
			this.userDetail.manufactrer = this.deviceDetails.browser;
			this.userDetail.model = this.deviceDetails.device;
			this.userDetail.platform = this.deviceDetails.os;
			this.userDetail.mobileVersion = this.deviceDetails.os_version;

			console.log("User Details: ", this.userDetail);
		});
	}

	public downloadPageManual(): void {
		window.open("./assets/manuals/" + "Portal-Manual.pdf");
	}

	public test(id): void {
		this.loginService.test(id).subscribe((res) => { });
	}

	deviceCheck() {
		this.deviceDetails = this.deviceService.getDeviceInfo();
	}
}
